class SiteElementBindActionButton
    extends QueryElement<HTMLElement> {

    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        var parent = this.parent();
        if (parent == null)
            throw "Unable to find parent.";

        let actionPath = this.getAttr('data-action');
        let action = card.Model.get((actionPath && SiteModel.split(actionPath)) || []);
        let actionSiteModel = new SiteModel(JSON.parse(JSON.stringify(action)));

        let modelPath = this.getAttr('data-path');
        let actionModel = card.Model.get((modelPath && SiteModel.split(modelPath)) || []);

        let modelSetPath = this.getAttr('data-set');
        let setPath = (modelSetPath && SiteModel.split(modelSetPath)) || [];

        let name: string | undefined;
        let actionNamePath = this.getAttr('data-config');
        if (actionNamePath != null)
            name = card.Model.get((actionNamePath && SiteModel.split(actionNamePath)) || []);

        let icon = this.query("i").first()?.getHtml() as Icons ?? undefined;

        actionSiteModel.set(setPath, "self", actionModel, true);
        let actionButton = actionSiteModel.get([]);

        new SiteActionButton(
            card, 
            {
                icon: icon,
                title: name,
                action: actionButton,
                isFocusable: false
            },
            document.createElement("div")
        ).appendTo(parent);

        this.remove();
    }
}